import {RefObject} from 'react';

export type ModalManagerCallback<T> = (arg?: T) => any;

export type ModalManagerRefObject = RefObject<ModalManager>;

export class ModalManager {
	protected destroyed: boolean = false;

	constructor(protected onOpenRequest: ModalManagerCallback<ModalManagerCallback<void>>, protected onCloseRequest: ModalManagerCallback<ModalManagerCallback<void>>) {
	}

	public open = (callback?: ModalManagerCallback<any>) => {
		if (!this.destroyed) {
			this.onOpenRequest(callback);
		}
	};

	public close = (callback?: ModalManagerCallback<any>) => {
		if (!this.destroyed) {
			this.onCloseRequest(callback);
		}
	};

	public destroy() {
		this.destroyed = true;
	}
}
